// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Ubuntu:wght@300&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*:before,
*:after {
  box-sizing: inherit;
  
}
body {
  overflow: hidden;
}

body,html{
  margin: 0;
  padding: 0;  
}
:root {
  --ColorPrimary: white;
  --ColorPrimaryDark: #313033;
  --ColorSecondary: #501D2E;
  --ColorSecondaryDark: #6A2A40;
  --ColorThird: white;
  --ColorThirdDark: white;
  --ColorFourth: #ffeaea;
  --ColorFourthDark: #48464a;
  --ColorShadow: #e6e6e6;
  --ColorShadowDark: #181a1f;
  --ColorLabelPrimary: #111316;
  --ColorLabelPrimaryDark: white;
  --ColorLabelSecondary: #79767b;
  --ColorLabelSecondaryDark: white;
  --ColorLabelThird: #48464a;
  --ColorLabelThirdDark: white;
  --ColorLabelRed: #6A2A40;
  --ColorLabelPlaceholder: #79767B;
  --ColorLabelPlaceholderDark: #79767B;
  --ColorLabelGreen: #469929;
}

.label-16-regular {
  font-family: "Nun", sans-serif;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  color: #000000;
}
.label-16-regular-white {
  font-family: "Nun", sans-serif;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  color: #ffffff;
}

.label-22-bold {
  font-family: "Nun", sans-serif;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.5;
  color: #000000;
}
.label-22-bold-white {
  font-family: "Nun", sans-serif;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.5;
  color: #ffffff;
}

.label-16-bold {
  font-family: "Nun", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  color: #000000;
}

.label-32-bold {
  font-family: "Nun", sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 1.5;
  color: #000000;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AACA;;;EAGE,mBAAmB;;AAErB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;EACxB,gCAAgC;EAChC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Ubuntu:wght@300&display=swap\");\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n  \n}\nbody {\n  overflow: hidden;\n}\n\nbody,html{\n  margin: 0;\n  padding: 0;  \n}\n:root {\n  --ColorPrimary: white;\n  --ColorPrimaryDark: #313033;\n  --ColorSecondary: #501D2E;\n  --ColorSecondaryDark: #6A2A40;\n  --ColorThird: white;\n  --ColorThirdDark: white;\n  --ColorFourth: #ffeaea;\n  --ColorFourthDark: #48464a;\n  --ColorShadow: #e6e6e6;\n  --ColorShadowDark: #181a1f;\n  --ColorLabelPrimary: #111316;\n  --ColorLabelPrimaryDark: white;\n  --ColorLabelSecondary: #79767b;\n  --ColorLabelSecondaryDark: white;\n  --ColorLabelThird: #48464a;\n  --ColorLabelThirdDark: white;\n  --ColorLabelRed: #6A2A40;\n  --ColorLabelPlaceholder: #79767B;\n  --ColorLabelPlaceholderDark: #79767B;\n  --ColorLabelGreen: #469929;\n}\n\n.label-16-regular {\n  font-family: \"Nun\", sans-serif;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000000;\n}\n.label-16-regular-white {\n  font-family: \"Nun\", sans-serif;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #ffffff;\n}\n\n.label-22-bold {\n  font-family: \"Nun\", sans-serif;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.5;\n  color: #000000;\n}\n.label-22-bold-white {\n  font-family: \"Nun\", sans-serif;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.5;\n  color: #ffffff;\n}\n\n.label-16-bold {\n  font-family: \"Nun\", sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.5;\n  color: #000000;\n}\n\n.label-32-bold {\n  font-family: \"Nun\", sans-serif;\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 1.5;\n  color: #000000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
